module.exports = __webpack_public_path__ + "img/zhongbiao.ee257c7a.svg";